// @flow
import { Enum } from '@rover/react-lib/types';

export default class AlertSeverity extends Enum<string> {
  static INFO = new AlertSeverity('info');

  static SUCCESS = new AlertSeverity('success');

  static WARNING = new AlertSeverity('warning');

  static DANGER = new AlertSeverity('danger');

  static isLocked = true;
}



// WEBPACK FOOTER //
// ../react-lib/src/components/notifications/Alert/AlertSeverity.js